/** Por quanto tempo o CPF completo fica na tela depois de "Ver CPF". */
export const CPF_REVEAL_MS = 30_000;

export interface RevealTimer {
  /** (Re)inicia a contagem; ao fim, chama onExpire. */
  start: () => void;
  /** Cancela a contagem (ex.: ao sair da tela). */
  stop: () => void;
}

/**
 * Contagem que esconde o CPF completo. O CPF fica só em estado local do componente, e onExpire/stop o apagam; nada vai
 * para o cache do TanStack Query nem para estado global.
 */
export function createRevealTimer(onExpire: () => void, durationMs = CPF_REVEAL_MS): RevealTimer {
  let handle: ReturnType<typeof setTimeout> | undefined;
  const stop = () => {
    if (handle !== undefined) clearTimeout(handle);
    handle = undefined;
  };
  return {
    start: () => {
      stop();
      handle = setTimeout(() => {
        handle = undefined;
        onExpire();
      }, durationMs);
    },
    stop,
  };
}
